
/**
 * Created by simonhutton on 17/03/17.
 */

import Backbone from 'backbone';
import $ from "jquery";
import _ from "underscore";
import { preventDefault, isValidEmail, setCookie, guid } from 'js_helper_app/module.helper.js';
import { closeModal, showModal } from 'js_helper_app/module.tail_helper.js';
import { getAuth, onAuthStateChanged, getRedirectResult, GoogleAuthProvider, signInWithRedirect, OAuthProvider, signInWithEmailAndPassword, PhoneMultiFactorGenerator, PhoneAuthProvider, getMultiFactorResolver, RecaptchaVerifier, sendPasswordResetEmail, TotpMultiFactorGenerator, isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";

export function initializeFirebase(){
    const auth = getAuth();

    onAuthStateChanged(auth, function (user) {
        if (user) {
            user.getIdToken(true).then(function (idToken) {
                window.logInView.loggedIn(idToken);
            });
        } else {
            // closeModal($('#signin-loading-modal'));
        }
    });

    getRedirectResult(auth)
        .then((result) => {
            /** @type {firebase.auth.OAuthCredential} */
            if (result){
                const credential = GoogleAuthProvider.credentialFromResult(result);

                // This gives you a Google Access Token. You can use it to access the Google API.
                var token = credential.accessToken;

                result.user.getIdToken(true).then(function (idToken) {
                    window.logInView.loggedIn(idToken);
                });
            }
        }).catch((authError) => {
            closeModal($('#signin-loading-modal'));

            if (authError.code === 'auth/multi-factor-auth-required') {
                // The user is a multi-factor user. Second factor challenge is required.
                challengeForMfa(authError);
            } else if (authError.code === "auth/account-exists-with-different-credential"){
                showModal($('#credentials-already-used-modal'));
            }
        });
}

function challengeForMfa(authError){
    const auth = getAuth();

    // The user is a multi-factor user. Second factor challenge is required.
    if (window.location.hostname === 'gaggle.email' || window.location.hostname === 'new-login-dot-gaggle-mail.appspot.com'){
        const resolver = getMultiFactorResolver(auth, authError);

        window.logInView.showMfaRequired(resolver);
    } else {
        var redirectUrl = "https://gaggle.email/login?destination=" + window.location.href + "&provider=" + authError.a.providerId;

        if (!_.isUndefined(window.logInView.orgId)){
            redirectUrl += '&org=' + window.logInView.orgId;
        }

        window.location.href = redirectUrl;
    }
}

$.fn.allchange = function (callback) {
        var me = this;
        var last = "";
        var infunc = function () {
            var text = $(me).val();
            if (text !== last) {
                last = text;
                callback();
            }
            setTimeout(infunc, 100);
        }
        setTimeout(infunc, 100);
    };

export default Backbone.View.extend({
    initialize: function () {
        var that = this;

        $(window).resize(function () {
            that.setDimensions();
        });

        _.delay(function(){
            that.setDimensions();
        }, 100);

        this.userEmailEl.allchange(function () {
            that.userEmailChanged(null);
        });

        _.bindAll(this, "loggedIn");
    },

    el: $('body'),

    events: {
        "click #login-btn":         "loginButtonClicked",
        "keyup #user-email":        "userEmailChanged",
        "keyup #user-password":     "userPasswordChanged",
        "change #user-email":        "userEmailChanged",
        "change #user-password":     "userPasswordChanged",
        "click #login-more-buttons":"moreLoginButtonsClicked",
        "click .login-modal-trigger": "openLoginClicked",
        "click #forgot-password":   "forgotPasswordClicked",
        "click #signin-forgot-password-cancel": "forgotPasswordCancelClicked",
        "click #signin-forgot-password-submit": "forgotPasswordSubmitClicked",
        "click #google-btn":        "googleLoginClicked",
        "click #apple-btn":        "appleLoginClicked",
        "click #microsoft-btn":     "microsoftLoginClicked",
        "click #sso-sign-in-btn":        "ssoLoginClicked",
        "click #mfa-validation-cancel": "mfaVerifyCancelClicked",
        "click #mfa-validation-submit": "mfaVerifySubmitClicked",
        "click #credentials-already-used-close":    "credentialAlreadyUsedClicked",
        "click #sign-in-via-email-btn":     "confirmSignInViaEmail",
        "keyup #mfa-validation-code":       "validationCodeKeyUp",
        "keyup #totp-validation-code":       "validationCodeKeyUp",
        "keyup #sign-in-via-email-email":    "signInViaEmailEmailChanged",
        "click #sign-in-with-email-btn":     "signInWithEmailButtonClicked",
        "click #sign-via-email-complete-close":     "signInViaEmailCloseClicked",
        "click #sign-in-manually-link":             "signInManuallyLinkClicked",
        "click #use-magic-link":                    "signInWithEmailLinkClicked",
        "keyup #forgot-password-email":             "forgotPasswordChanged"
    },

    footerEl: $('#page-footer'),

    userEmailEl: $('#user-email'),
    userPasswordEl: $('#user-password'),
    rememberMeEl: $('#remember-me'),
    loginButtonEl: $('#login-btn'),

    wrongEmailAddressEl: $('#wrong-email-address-panel'),

    destinationValueEl: $('#login-destination'),

    alwaysShowPassword: false,

    loadingModalEl: $('#signin-loading-modal'),
    forgotPasswordModalEl: $('#forgot-password-modal'),
    mfaValidationModalEl: $('#mfa-validation-modal'),
    credentialsAlreadyUsedEl: $('#credentials-already-used-modal'),

    loginFailedMessageEl: $('#signin-failed-message'),

    forgotPasswordEmailEl: $('#forgot-password-email'),
    mfaVerificationCodeEl: $('#mfa-validation-code'),
    totpVerificationCodeEl: $('#totp-validation-code'),

    signInMessageEl: $('#signin-message'),

    mfaModalSmsSection: $('#mfa-modal-sms-section'),
    mfaModalOrSection: $('#mfa-modal-or-section'),
    mfaModalTotpSection: $('#mfa-modal-totp-section'),
    signInViaEmailInputEL: $('#sign-in-via-email-email'),
    signInViaEmailPanelEL: $('#sign-in-via-email-panel'),

    signInViaEmailCompleteModelEl: $('#sign-via-email-complete-modal'),
    signInViaEmailCompleteModelCloseEl: $('#sign-via-email-complete-close'),
    signInViaEmailBannerEl: $('#sign-in-with-email-btn-banner'),

    signInWithEmailContainerEl: $('#sign-in-with-email-btn-container'),
    loginButtonContainerEl: $('#login-btn-container'),
    loginWithPasswordContainerEl: $('#login-with-password-container'),

    setDimensions: function () {
    },

    loginButtonClicked: function(event){
        preventDefault(event);

        this.login();
    },

    userEmailChanged: function(event){
        this.inputChanged();

        if(event != null && event.keyCode === 13) {
            if (this.userPasswordEl.is(':visible')){
                this.userPasswordEl.focus();
            } else {
                this.signInWithEmailButtonClicked();
            }
        }
    },

    userPasswordChanged: function(event){
        this.inputChanged();

        if(event.keyCode === 13) {
            this.login();
        }
    },

    validationCodeKeyUp: function(){
        if(event.keyCode === 13) {
            this.mfaVerifySubmitClicked();
        }
    },

    inputChanged: function(){
        var userEmail = this.userEmailEl.val();
        var userPassword = this.userPasswordEl.val();

        if (isValidEmail(userEmail) && userPassword.length > 0) {
            this.loginButtonEl.removeClass('disabled');
        } else {
            this.loginButtonEl.addClass('disabled');
        }

        if (userEmail && (userEmail.indexOf("@gaggle.email") !== -1 || userEmail.indexOf("@gaggle.com") !== -1) ){
            this.wrongEmailAddressEl.slideDown('fast');
            this.loginButtonEl.addClass('disabled');
        } else {
            this.wrongEmailAddressEl.slideUp('fast');
        }

        this.hideLoginFailed();
    },

    login: function(){
        if (this.loginButtonEl.hasClass('disabled')){
            return;
        }

        var that = this;
        var userEmail = this.userEmailEl.val();
        var userPassword = this.userPasswordEl.val();

        this.hideLoginFailed();
        this.showLoginPreLoader();

        const auth = getAuth();

        signInWithEmailAndPassword(auth, userEmail, userPassword).catch(function (authError) {
            if (authError.code === 'auth/multi-factor-auth-required') {
                // The user is a multi-factor user. Second factor challenge is required.
                if (window.location.hostname === 'gaggle.email' || window.location.hostname === 'new-login-dot-gaggle-mail.appspot.com'){
                    const resolver = getMultiFactorResolver(auth, authError);

                    that.showMfaRequired(resolver);
                } else {
                    var preAuthData = {
                        'token': btoa(userPassword),
                        'guid': guid()
                    };

                    $.ajax({
                        type: "POST",
                        url: '/pre-authenticate',
                        data: JSON.stringify(preAuthData),
                        dataType: "json",
                        contentType: "application/json",
                        success: function () {
                             var redirectUrl= "https://gaggle.email/login?destination=" + window.location.href +
                                "&preauth=" + preAuthData['guid'] +
                                "&email=" + userEmail +
                                "&provider=password";

                             if (!_.isUndefined(that.orgId)){
                                 redirectUrl += '&org=' + that.orgId;
                             }

                             window.location.href = redirectUrl;
                        },
                        fail: function () {
                            window.location.href = "https://gaggle.email/login?destination=" + window.location.href;
                        }});
                }

                return;
            }

            var data = {
                'user-email': userEmail,
                'user-password': userPassword
            };

            $.post("/login", data).done(function(){
                if (that.destinationValueEl.val()){
                    window.location.href = that.destinationValueEl.val();
                } else {
                    window.location.reload();
                }
            }).fail(function(xhr, status, error){
                try {
                    var message = authError.message;

                    console.log(authError.message);

                    if (xhr.responseText) {
                        var data = JSON.parse(xhr.responseText);

                        if (data['message']) {
                            message = data['message'];
                        }
                    }
                }
                catch (err){
                }

                that.showLoginFailed(message);
            }).always(function(){
                that.hideLoginPreLoader();
            });
        });
    },

    loggedIn: function (token){
        setCookie('accessToken', token, 1);

        window.location.href = '/logged-in?destination=' + this.destinationValueEl.val();
    },

    hideLoginFailed: function(){
        this.loginFailedMessageEl.html("");
        this.loginFailedMessageEl.hide();
    },

    showLoginPreLoader: function(message){
        if (message){
            this.signInMessageEl.html(message);
        } else {
            this.signInMessageEl.html("Signing in...");
        }

        showModal(this.loadingModalEl);
    },

    showMfaRequired: function (resolver){
        var that = this;

        this.resolver = resolver;

        if (this.resolver){
            const auth = getAuth();

            this.recaptchaVerifier = new RecaptchaVerifier(auth,'ip-login-recaptcha-container-id',{
                'size': 'invisible',
                'callback': function(response) {
                  // reCAPTCHA solved, you can proceed with phoneAuthProvider.verifyPhoneNumber(...).
                }
            }, auth);

            const enrolledFactors = this.resolver.hints.map(info => info.factorId);

            this.showMfaModal(enrolledFactors);
        } else {
            this.loginFailedMessageEl.html("Resolver not found.  Please contact support.");

            this.loginFailedMessageEl.show();
        }
    },

    mfaVerifyCancelClicked: function(){
        closeModal(this.mfaValidationModalEl);
    },

    mfaVerifySubmitClicked: function (){
        var that = this;

        closeModal(this.mfaValidationModalEl);
        this.showLoginPreLoader();

        const smsVerificationCode = this.mfaVerificationCodeEl.val();
        const totpVerificationCode = this.totpVerificationCodeEl.val();

        const auth = getAuth();

        if (smsVerificationCode && smsVerificationCode.length === 6){
            var cred = PhoneAuthProvider.credential(
                this.verificationId, smsVerificationCode);

            var multiFactorAssertion = PhoneMultiFactorGenerator.assertion(cred);
            // Complete sign-in.
            this.resolver.resolveSignIn(multiFactorAssertion).catch(function(error){
                that.hideLoginPreLoader();

                that.loginFailedMessageEl.html("Incorrect code, please try again.");

                that.loginFailedMessageEl.show();
            });
        } else if (totpVerificationCode){
            const totpHint = this.getMfaHint(TotpMultiFactorGenerator.FACTOR_ID);

            const totpMultiFactorAssertion = TotpMultiFactorGenerator.assertionForSignIn(
                totpHint.uid,
                totpVerificationCode
            );  // this.resolver.hints[selectedIndex].uid,

            this.resolver.resolveSignIn(totpMultiFactorAssertion).catch(function(error){
                that.hideLoginPreLoader();

                that.loginFailedMessageEl.html("Incorrect code, please try again.");

                that.loginFailedMessageEl.show();
            });
        } else {
            that.hideLoginPreLoader();

            that.loginFailedMessageEl.html("Incorrect code, please try again.");

            that.loginFailedMessageEl.show();
        }
    },

    hideLoginPreLoader: function(){
        closeModal(this.loadingModalEl);
    },

    showLoginFailed: function(message){
        if (!message){
            message = "Sign in failed.  Please check your details and try again.";
        }

        if (message.indexOf("user-not-found") !== -1){
            var email = this.userEmailEl.val();
            var destination = '/signup?destination=' + this.destinationValueEl.val() + '&email=' + email;

            this.loginFailedMessageEl.html("<div class='text-gray-700'>No account found for <span class='font-bold'>" + email + "</span><br><a class='underline' href='" + destination + "'>Click here</a> to create an account</div>");
        } else if (message.indexOf("auth/wrong-password") !== -1) {
            this.loginFailedMessageEl.html("Incorrect password — please check and try again.");
        } else {
            this.loginFailedMessageEl.html(message);
        }

        this.loginFailedMessageEl.show();
    },

    userPasswordKeyUp: function(event){
        if(event.keyCode === 13){
            this.login();
        }
    },

    moreLoginButtonsClicked: function(event) {
        preventDefault(event);

        this.$el.find('.collapsed-connect-btn').slideDown();

        this.$el.find('#login-more-buttons').hide();
    },

    forgotPasswordClicked: function (event){
        preventDefault(event);

        this.hideLoginFailed();

        this.forgotPasswordEmailEl.val(this.userEmailEl.val());
        showModal(this.forgotPasswordModalEl);
        this.forgotPasswordEmailEl.focus();
    },

    forgotPasswordCancelClicked: function (){
        closeModal(this.forgotPasswordModalEl);
    },

    forgotPasswordSubmitClicked: function (){
        var that = this;

        this.showLoginPreLoader("Sending password reset email...");
        closeModal(that.forgotPasswordModalEl);

        $.ajax({
            type: "POST",
            url: '/forgot-password',
            data: JSON.stringify({'forgot-password-email': this.forgotPasswordEmailEl.val()}),
            dataType: "json",
            contentType: "application/json",
            success: function () {
                window.location.href = "/";
            },
            error: function (xhr, status, error) {
                var data = JSON.parse(xhr.responseText);

                that.loginFailedMessageEl.html(data['message']);

                that.loginFailedMessageEl.show();

                that.hideLoginPreLoader();
            }});
        },

    googleLoginClicked: function (){
        this.showLoginPreLoader();

        var provider = new GoogleAuthProvider();
        const auth = getAuth();

        window.sessionStorage.setItem('login-pending', 1);

        signInWithRedirect(auth, provider);
    },

    appleLoginClicked: function (){
        this.showLoginPreLoader();

        var provider = new OAuthProvider('apple.com');
        const auth = getAuth();

        provider.addScope('email');
        provider.addScope('name');

        window.sessionStorage.setItem('login-pending', 1);

        signInWithRedirect(auth, provider);
    },

    microsoftLoginClicked: function (){
        this.showLoginPreLoader();

        var provider = new OAuthProvider('microsoft.com');
        const auth = getAuth();

        window.sessionStorage.setItem('login-pending', 1);

        signInWithRedirect(auth, provider);
    },

    ssoLoginClicked: function (){
        this.showLoginPreLoader();

        var provider = new OAuthProvider(window.ssoProvider);
        const auth = getAuth();

        provider.addScope('email');
        provider.addScope('name');

        window.sessionStorage.setItem('login-pending', 1);

        signInWithRedirect(auth, provider);
    },

    showMfaModal: function(enrolledFactors){
        var that = this;

        if (enrolledFactors.indexOf("phone") !== -1){
            this.mfaModalSmsSection.show();

            const auth = getAuth();

            const smsHint = this.getMfaHint(PhoneMultiFactorGenerator.FACTOR_ID);

            var phoneInfoOptions = {
                multiFactorHint: smsHint,
                session: this.resolver.session
            };
            var phoneAuthProvider = new PhoneAuthProvider(auth);

            // Send SMS verification code
            phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, that.recaptchaVerifier)
                .then(function(verificationId) {
                    that.verificationId = verificationId;
                    // Ask user for the SMS verification code.
                })
                .then(function(userCredential) {
                // User successfully signed in with the second factor phone number.
            }).catch(function(error){
                if (error.code === "auth/captcha-check-failed"){
                    window.location.reload();
                } else {
                    that.hideLoginPreLoader();
                    closeModal(that.mfaValidationModalEl);

                    that.loginFailedMessageEl.html(error.message);

                    that.loginFailedMessageEl.show();
                }
            });
        } else {
            this.mfaModalSmsSection.hide();
        }

        if (enrolledFactors.indexOf("totp") !== -1){
            this.mfaModalTotpSection.show();
        } else {
            this.mfaModalTotpSection.hide();
        }

        if (enrolledFactors.length > 1){
            this.mfaModalOrSection.show();
        } else {
            this.mfaModalOrSection.hide();
        }

        showModal(this.mfaValidationModalEl);
    },

    getMfaHint: function(factorId){
        if (!this.resolver){
            return null;
        }

        return _.find(this.resolver.hints, function(h){
            return h.factorId === factorId;
        })
    },

    credentialAlreadyUsedClicked: function (){
       closeModal(this.credentialsAlreadyUsedEl);
    },

    checkSignInViaEmail: function (){
        const auth = getAuth();
        var that = this;

        if (isSignInWithEmailLink(auth, window.location.href)) {
            var email = window.localStorage.getItem('emailForSignIn');

            if (email) {
                that.signInViaEmailInputEL.val(email);
                window.localStorage.removeItem('emailForSignIn');

                that.confirmSignInViaEmail();
            } else{
                closeModal($('#signin-loading-modal'));
            }

            return true;
        }

        return false;
    },

    confirmSignInViaEmail: function(){
        const auth = getAuth();
        var that = this;
        var email = this.signInViaEmailInputEL.val();

        this.showLoginPreLoader("Signing in via email...");

        this.signInViaEmailPanelEL.hide();

        signInWithEmailLink(auth, email, window.location.href)
            .then((result) => {
                if (result.user) {
                    result.user.getIdToken(true).then(function (idToken) {
                        that.loggedIn(idToken);
                    });
                } else {
                    closeModal($('#signin-loading-modal'));
                }
            }).catch((authError) => {
                // Some error occurred, you can inspect the code: error.code
                // Common errors could be invalid email and invalid or expired OTPs.
                if (authError.code === 'auth/multi-factor-auth-required') {
                    // The user is a multi-factor user. Second factor challenge is required.
                    closeModal($('#signin-loading-modal'));
                    challengeForMfa(authError);
                } else if (authError.code === "auth/account-exists-with-different-credential"){
                    closeModal($('#signin-loading-modal'));
                    showModal($('#credentials-already-used-modal'));
                } else if (authError.code === "auth/invalid-action-code"){
                    closeModal($('#signin-loading-modal'));
                    var url = `/signup?email=${email}&destination=${that.destinationValueEl.val()}`;

                    that.signInViaEmailPanelEL.show();
                    that.signInViaEmailPanelEL.html(`<span class='text-gray-700'>Magic Link already used.  Please <a class='font-medium text-teal-600 hover:text-teal-500' href='${url}'>request a new one</a>.</span>`);
                } else {
                    closeModal($('#signin-loading-modal'));
                    that.signInViaEmailPanelEL.show();
                    that.signInViaEmailPanelEL.html(authError.message);

                    window.trackJs && trackJs.track("signInWithEmailLink failed with email: " + email + " and destination: " + window.location.href);
                    window.trackJs && trackJs.track(authError.code);
                    window.trackJs && trackJs.track(authError.message);
                    window.trackJs && trackJs.track(authError);
                }
        });
    },

    signInViaEmailEmailChanged: function (event){
        if(event.keyCode === 13) {
            this.confirmSignInViaEmail();
        }
    },

    signInWithEmailButtonClicked: function (){
        var that = this;
        var email = this.userEmailEl.val();

        if (!isValidEmail(email)){
            this.loginFailedMessageEl.show();

            if (email.length === 0){
                this.loginFailedMessageEl.html("Please enter your email address.");
            } else {
                this.loginFailedMessageEl.html("Sorry, but that's not a valid email address.");
            }

            return;
        }

        this.showLoginPreLoader("Please wait...");

        var data = {
            'email': email,
            'destination': this.destinationValueEl.val(),
            'messageType': 'signin'
        };

        $.ajax({
            type: "POST",
            url: '/send-sign-in-email-link',
            data: JSON.stringify(data),
            dataType: "json",
            contentType: "application/json",
            success: function () {
                window.localStorage.setItem('emailForSignIn', email);

                closeModal(that.loadingModalEl);

                that.signInViaEmailCompleteModelEl.find('#sign-via-email-complete-modal-email').html(email);

                showModal(that.signInViaEmailCompleteModelEl);
                that.signInViaEmailCompleteModelCloseEl.focus();
                // that.signInViaEmailBannerEl.slideDown('fast');
            },
            error: function (xhr, status, error) {
                var data = JSON.parse(xhr.responseText);

                that.passwordIsNotValidMessageEl.html("Create Account Failed. We have been informed.");
                that.passwordIsNotValidMessageEl.show();

                closeModal(that.loadingModalEl);
            }});
    },

    signInViaEmailCloseClicked: function (){
        closeModal(this.signInViaEmailCompleteModelEl);
    },

    loginWithPassword: function (){
        this.signInViaEmailBannerEl.hide();
        this.signInWithEmailContainerEl.hide();
        this.loginButtonContainerEl.show();
        this.loginWithPasswordContainerEl.show();

        if (this.userEmailEl.val().length < 5){
            this.userEmailEl.focus();
        } else {
            this.userPasswordEl.focus();
        }
    },

    signInManuallyLinkClicked: function (event){
        preventDefault(event);

        window.location.href = `/login?destination=${this.destinationValueEl.val()}&email=${encodeURIComponent(this.userEmailEl.val())}&provider=password`;
    },

    signInWithEmailLinkClicked: function (event){
        preventDefault(event);

        window.location.href = `/login?destination=${this.destinationValueEl.val()}&email=${encodeURIComponent(this.userEmailEl.val())}`;
    },

    forgotPasswordChanged: function(event){
        if(event.keyCode === 13) {
            this.forgotPasswordSubmitClicked();
        }
    },
});
